import styled from "@emotion/styled";

export const Section = styled.section`
  padding: 30px;
  border: 1px solid #bfbfbf;
  margin: auto;
  background-color: white;
  margin: 15px 0;
  border-radius: 5px;
`;
